import { render, staticRenderFns } from "./ProductionTargetSwitch.vue?vue&type=template&id=7a974f5b&scoped=true&"
import script from "./ProductionTargetSwitch.vue?vue&type=script&lang=js&"
export * from "./ProductionTargetSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTargetSwitch.vue?vue&type=style&index=0&id=7a974f5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a974f5b",
  null
  
)

export default component.exports